import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import NumberFormat from 'react-number-format';

export default class Escalation extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true
        };
    }
    componentDidMount() {
        this.httpPost("api/v1/escalation/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        e.preventDefault();
        this.httpPost("api/v1/escalation/save", {
            id: this.getCurrentFormId(),
            salaryYear: parseInt(this.state.data.salaryYear),
            record: this.state.data.record,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.setState({
                        redirect: '/escalation'
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    getYearList() {
        var list = [];
        for (var i = this.state.data.currentShamsiYear; i >= this.state.data.currentShamsiYear - 40; i--) list.push(i);
        return list;
    }
    setField(id, field, value) {
        this.state.data.record.forEach(f => {
            if (f.id === id) f[field] = value;
        });
    }
    changeYear(e) {
        this.state.data.salaryYear = e;
        this.state.data.record.forEach(rec => {
            rec.employeeYear = e;
            e--;
        });
        this.setState({ data: this.state.data });
    }
    renderForm() {
        return <div className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="components-preview wide-md mx-auto">
                            <div className="nk-block nk-block-lg">
                                <div className="card card-bordered">
                                    <div className="card-inner">
                                        <div className="card-head">
                                            <h5 className="card-title">اطلاعات جدول تصاعدی حقوق</h5>
                                        </div>
                                        <form method="post" onSubmit={e => this.save(e)} className="row g-4">
                                            <div className="col-lg-12">
                                                <div className="form-group">
                                                    <label className="form-label">سال</label>
                                                    <div className="form-control-wrap">
                                                        <select className="form-control text-center" type="text" defaultValue={this.state.data.salaryYear} onChange={e => this.changeYear(parseInt(e.target.value))}>
                                                            {this.getYearList().map(p => <option value={p}>{p}</option>)}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            {this.state.data.record.map(rec => [
                                                <div className="col-lg-3">
                                                    <div className="form-group">
                                                        <label className="form-label">سال استخدام</label>
                                                        <div className="form-control-wrap">
                                                            <NumberFormat value={rec.employeeYear} onChange={e => this.setField(rec.id, 'employeeYear', this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, '')))} prefix={''} className='form-control text-center' />
                                                        </div>
                                                    </div>
                                                </div>
                                                ,
                                                <div className="col-lg-3">
                                                    <div className="form-group">
                                                        <label className="form-label">مبلغ حقوق</label>
                                                        <div className="form-control-wrap">
                                                            <NumberFormat value={rec.price} onChange={e => this.setField(rec.id, 'price', this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                        </div>
                                                    </div>
                                                </div>
                                            ])}
                                            <div className="col-lg-12">
                                                <div className="form-group">
                                                    <button type="submit" className="btn btn-lg btn-primary">ذخیره</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}